import { PARTNERS } from "@/data/site";

export default function PartnerLogos({ interactive = true, title = true }) {
  return (
    <div data-testid="partner-logos" className="w-full">
      {title && (
        <div className="text-center mb-10">
          <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#FF3B30] mb-3">Yazılım İş Ortaklarımız</div>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-[#0A0A0A]">Yetkili. Güvenilir. Sürdürülebilir.</h2>
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
        {PARTNERS.map((p) => (
          <div
            key={p.slug}
            data-testid={`partner-${p.slug}`}
            className="group relative aspect-[4/3] rounded-2xl bg-white border border-[#E5E5EA] p-5 flex items-center justify-center overflow-hidden hover:-translate-y-1 transition-transform duration-300"
          >
            <img
              src={p.logo}
              alt={p.name}
              className={`max-h-full max-w-full object-contain transition-all duration-500 ${
                interactive ? "grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100" : ""
              }`}
            />
            <div className="absolute inset-x-0 bottom-0 px-3 py-2 text-[11px] font-semibold text-[#0A0A0A] opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all bg-gradient-to-t from-white via-white to-transparent">
              {p.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
